import { Box, Button, Flex, IconFont, type Option, Select, Tag, Text } from '@byecode/ui'
import { type AggregateResultField, FieldTypeTag, innerTypeToFieldTypeIconMap } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import * as SC from './styles'

interface UnionItemProps {
    primaryField: AggregateResultField | undefined
    unionFieldList: AggregateResultField[]
    unionFieldIds: string[]
    value: string
    disabledDelete?: boolean
    onChange: (value: string) => void
    onDelete: () => void
}

export const UnionItem: React.FC<UnionItemProps> = ({
    primaryField,
    unionFieldList,
    unionFieldIds,
    value,
    disabledDelete,
    onChange,
    onDelete
}) => {
    const unionFieldOptions = useMemo(() => {
        return unionFieldList?.reduce<Option[]>((prev, cur) => {
            if (cur.innerType === primaryField?.innerType && (!unionFieldIds.includes(cur.id) || value === cur.id)) {
                prev.push({
                    label: cur.name,
                    value: cur.id,
                    extra: <FieldTypeTag type={cur.type} innerType={cur.innerType} />
                })
            }
            return prev
        }, [])
    }, [primaryField?.innerType, unionFieldIds, unionFieldList, value])

    const currentUnionField = useMemo(() => {
        return unionFieldList.find(item => item.id === value)
    }, [unionFieldList, value])

    const primaryFieldTag = useMemo(() => {
        if (!primaryField) {
            return (
                <SC.ErrorTag>
                    <Text color="var(--color-red-500)">找不到变量</Text>
                </SC.ErrorTag>
            )
        }
        return (
            <Flex alignItems="center" gap={6}>
                <IconFont size={16} type={innerTypeToFieldTypeIconMap[primaryField.innerType]} />
                <Text>{primaryField.name}</Text>
            </Flex>
        )
    }, [primaryField])

    return (
        <SC.ListItem>
            <SC.Cell>{primaryFieldTag}</SC.Cell>
            <SC.Operator>
                <SC.Line />
            </SC.Operator>
            <SC.Cell>
                <Select
                    clearable
                    searchable
                    notFound="字段类型不匹配"
                    prefix={currentUnionField && <IconFont size={16} type={innerTypeToFieldTypeIconMap[currentUnionField.innerType]} />}
                    style={{ width: '100%' }}
                    options={unionFieldOptions}
                    value={value}
                    onChange={onChange}
                />
            </SC.Cell>
            <Button
                disabled={disabledDelete}
                type="text"
                onClick={onDelete}
                icon={<IconFont type="Trash" size={16} color="var(--color-gray-400)" />}
            />
        </SC.ListItem>
    )
}
